import { render } from "./NavTab.vue?vue&type=template&id=7bcedf6e"
import script from "./NavTab.vue?vue&type=script&lang=js"
export * from "./NavTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__